module.exports = __webpack_public_path__ + "img/qingyang5.1285cefb.png";